<template>
  <div
    ref="myPage"
    style="width: calc(100% - 10px); height: calc(100vh - 100px)"
  >
    <SeeksRelationGraph ref="seeksRelationGraph" :options="graphOptions">
      <el-card class="box-card" slot="node" slot-scope="{ node }">
        <div slot="header" class="clearfix">
          <p>{{ node.data.type.desc }}</p>
          <el-button type="text" @click="gotoRouter(node)">{{
            node.data.code
          }}</el-button>
        </div>
        <div style="height: 100px">
          <p v-if="node.data.storageLayerNames">
            仓位:{{ node.data.storageLayerNames }}
          </p>
          <p v-if="node.data.deliveryNoteWarehousingInState">
            入库状态:{{ node.data.deliveryNoteWarehousingInState.desc }}
          </p>
          <p v-if="node.data.deliveryNoteWarehousingOutState">
            出库状态: {{ node.data.deliveryNoteWarehousingOutState.desc }}
          </p>
          <p v-if="node.data.state">状态: {{ node.data.state.desc }}</p>
          <p v-if="node.data.createAt">
            日期:{{ node.data.createAt | timeParser }}
          </p>
          <p v-if="node.data.factoryName">
            工厂名称:{{ node.data.factoryName }}
          </p>
          <p v-if="node.data.auditState">
            验审状态:{{ node.data.auditState.desc }}
          </p>
          <p v-if="node.data.transshipInfo">
            驳回信息:{{ node.data.transshipInfo }}
          </p>
          <p v-if="node.data.shippingSpaceState">
            订舱状态:{{ node.data.shippingSpaceState.desc }}
          </p>
          <p v-if="node.data.allocationState">
            分配状态:{{ node.data.allocationState.desc }}
          </p>
          <p v-if="node.data.stage">报关状态:{{ node.data.stage.desc }}</p>
          <p v-if="node.data.declarationTime">
            报关时间:{{ node.data.declarationTime | timeParser }}
          </p>
          <p v-if="node.data.collectInvoiceDate">
            预录单核对时间:{{ node.data.collectInvoiceDate | timeParser }}
          </p>
          <p v-if="node.data.checkPrerecordListDate">
            发票收取时间:{{ node.data.checkPrerecordListDate | timeParser }}
          </p>
        </div>
        <el-button
          type="primary"
          size="mini"
          @click="getDocumentFlow(node)"
          style="margin-bottom: 3px"
          >定位
        </el-button>
        <el-button
          type="primary"
          size="mini"
          v-if="node.data.type.desc === '装箱单'"
          @click="shipmentPosition(node)"
          >发货定位
        </el-button>
      </el-card>
    </SeeksRelationGraph>
  </div>
</template>
<script>
// import SeeksRelationGraph from "relation-graph"
export default {
  // components: { SeeksRelationGraph },
  props: {
    graphOptions: {
      type: Object
    },
    data: {
      type: Object
    },
  },
  data() {
    return {
      g_loading: true,
    };
  },
  watch: {},
  methods: {
    setGraphData() {
      // 使用要点：通过节点属性expandHolderPosition: 'right' 和 expanded: false 可以让节点在没有子节点的情况下展示一个"展开"按钮
      //         通过onNodeExpand事件监听节点，在被展开的时候有选择的去从后台获取数据，如果已经从后台加载过数据，则让当前图谱根据当前的节点重新布局
      this.g_loading = false;
      const seeksRelationGraph = this.$refs.seeksRelationGraph;
      seeksRelationGraph.setJsonData(this.data, (seeksRGGraph) => {
        // 这些写上当图谱初始化完成后需要执行的代码
        console.log(seeksRGGraph)
      });
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-select,
.el-date-editor,
.el-radio-group,
.el-upload {
  width: 100% !important;
  text-align: left;
}

a {
  color: blue;
  cursor: pointer;
}
</style>
